module.exports = __webpack_public_path__ + "assets/img/icon12.93491765.png";